"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _CheckboxRadio = _interopRequireDefault(require("../baseComponents/CheckboxRadio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DataTable = /*#__PURE__*/function (_Component) {
  _inherits(DataTable, _Component);

  var _super = _createSuper(DataTable);

  function DataTable(props) {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _super.call(this, props);
    _this.state = {
      selectedColIndex: props.selectedColIndex,
      sort: props.sort,
      selectedRowIndex: props.selectedRowIndex,
      selectAllChecked: props.selectAllChecked
    };
    _this.handleHeadingClick = _this.handleHeadingClick.bind(_assertThisInitialized(_this));
    _this.handleRowSelect = _this.handleRowSelect.bind(_assertThisInitialized(_this));
    _this.fillHeader = _this.fillHeader.bind(_assertThisInitialized(_this));
    _this.fillContent = _this.fillContent.bind(_assertThisInitialized(_this));
    _this.toggleSelectAll = _this.toggleSelectAll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DataTable, [{
    key: "handleHeadingClick",
    value: function handleHeadingClick(e, index, colExtra) {
      var sorting = "";

      if (this.props.enableSort) {
        sorting = this.state.sort;
        var isSwitching = this.state.selectedColIndex !== index;

        if (isSwitching) {
          sorting = 'desc';
        }

        if (this.state.selectedColIndex != null && !isSwitching) {
          if (this.state.sort === 'asc') {
            sorting = 'desc';
          } else {
            sorting = 'asc';
          }
        }

        this.setState({
          selectedColIndex: index,
          sort: sorting
        });
      }

      if (this.props.onHeadingClick) {
        this.props.onHeadingClick(e, index, sorting, colExtra);
      }
    }
  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      var forceState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.setState({
        selectAllChecked: forceState !== null ? forceState : !this.state.selectAllChecked
      });
    }
  }, {
    key: "setRowIndexes",
    value: function setRowIndexes(rowsIndexes) {
      this.setState({
        selectedRowIndex: rowsIndexes
      });
    }
  }, {
    key: "handleRowSelect",
    value: function handleRowSelect(e, rowIndex) {
      var selectAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var rowExtra = arguments.length > 3 ? arguments[3] : undefined;
      var rowsIndexes = this.state.selectedRowIndex;

      if (selectAll) {
        rowsIndexes = [];
        var rowCount = this.props.tableContent.length;

        if (this.props.selectingIcon) {
          for (var i = 0; i < rowCount; i++) {
            rowsIndexes.push(i);
          }

          this.setRowIndexes(rowsIndexes);
          return;
        } else {
          if (this.state.selectAllChecked) {
            rowsIndexes = [];
            this.setRowIndexes(rowsIndexes);
            this.toggleSelectAll();

            if (this.props.onDataSelect) {
              this.props.onDataSelect(e, selectAll ? "none" : rowIndex, rowsIndexes, rowExtra);
            }

            return;
          } else {
            for (var _i = 0; _i < rowCount; _i++) {
              rowsIndexes.push(_i);
            }

            this.toggleSelectAll();
          }
        }
      } else {
        var foundRowIndex = rowsIndexes.indexOf(rowIndex);

        if (foundRowIndex === -1) {
          rowsIndexes.push(rowIndex);
        } else {
          rowsIndexes.splice(foundRowIndex, 1);
        }

        if (rowsIndexes.length === 0 && this.state.selectAllChecked) {
          this.toggleSelectAll(false);
        }

        if (this.props.tableContent.length === rowsIndexes.length) {
          this.toggleSelectAll(true);
        }
      }

      this.setRowIndexes(rowsIndexes);

      if (this.props.onDataSelect) {
        this.props.onDataSelect(e, selectAll ? "all" : rowIndex, rowsIndexes, rowExtra);
      }
    }
  }, {
    key: "fillHeader",
    value: function fillHeader(content, isSticky) {
      var _this2 = this;

      var header = content.map(function (col, index) {
        var _classNames;

        var colIndex = isSticky ? _this2.props.headerContent.length - _this2.props.lastStickyColumnCount + index : index;
        var sorting = _this2.state.selectedColIndex === colIndex && _this2.props.enableSort;
        var headerColClasses = (0, _classnames["default"])("dataTable-header-col", "dataTable-col", col.className, (_classNames = {
          "isSorting": sorting,
          "notSortable": col.notSortable === true
        }, _defineProperty(_classNames, _this2.state.sort, sorting), _defineProperty(_classNames, "stickyHead", isSticky), _defineProperty(_classNames, "withBorders", _this2.props.withBorders), _classNames));
        var onClick = {
          onClick: function onClick(e) {
            _this2.handleHeadingClick(e, colIndex, col.extra);
          }
        };

        if (col.notSortable === true) {
          onClick = null;
        }

        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: headerColClasses,
          style: col.style,
          key: "header-col-".concat(colIndex)
        }, onClick), col.content, col.notSortable !== true && /*#__PURE__*/_react["default"].createElement("div", {
          className: "iconContainer"
        }, _this2.props.sortingIcon ? _this2.props.sortingIcon : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          name: "micro-glyph-arrow"
        })));
      });

      if (this.props.selectableData && !isSticky) {
        header.unshift( /*#__PURE__*/_react["default"].createElement("div", {
          key: "header-select-col",
          className: "dataTable-col dataTable-select-col",
          onClick: function onClick(e) {
            _this2.handleRowSelect(e, null, true);
          }
        }, this.props.selectingIcon ? this.props.selectingIcon : /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
          type: "checkbox",
          checked: this.state.selectAllChecked
        })));
      }

      return header;
    }
  }, {
    key: "fillContent",
    value: function fillContent(content) {
      var _this3 = this;

      var hasSticky = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isSticky = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return content.map(function (rowEl, rowIndex) {
        var isSelected = _this3.props.checkSelectionById ? _this3.props.selectedRowsIds.indexOf((rowEl.extra || {}).id) !== -1 && _this3.props.selectableData : _this3.state.selectedRowIndex.indexOf(rowIndex) !== -1 && _this3.props.selectableData;
        var rowClasses = (0, _classnames["default"])("dataTable-row", "dataTable-content-row", rowEl.className, {
          "selected": isSelected
        });
        var iterableRow;

        if (hasSticky) {
          iterableRow = isSticky ? rowEl.cols.slice(rowEl.cols.length - _this3.props.lastStickyColumnCount) : rowEl.cols.slice(0, -_this3.props.lastStickyColumnCount);
        } else {
          iterableRow = rowEl.cols;
        }

        var cols = iterableRow.map(function (colEl, colIndex) {
          var actualColIndex = isSticky ? _this3.props.headerContent.length - _this3.props.lastStickyColumnCount + colIndex : colIndex;
          var sorting = _this3.state.selectedColIndex === actualColIndex && _this3.props.enableSort;
          var colClasses = (0, _classnames["default"])("dataTable-col", "dataTable-content-col", colEl.className, {
            "isSorting": sorting,
            "stickyCol": isSticky,
            "withBorders": _this3.props.withBorders,
            "clickableRow": _this3.props.onRowClick && colEl.notClickable !== true
          });
          var onClick = null;

          if (_this3.props.onRowClick && colEl.notClickable !== true) {
            onClick = {
              onClick: function onClick(e) {
                _this3.props.onRowClick(e, rowIndex, rowEl.extra, colEl.extra);
              }
            };
          }

          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            className: colClasses,
            style: colEl.style,
            key: "row-col-".concat(actualColIndex)
          }, onClick), colEl.content);
        });

        if (_this3.props.selectableData && !isSticky) {
          cols.unshift( /*#__PURE__*/_react["default"].createElement("div", {
            key: "tableContent-select-col",
            className: "dataTable-col dataTable-select-col"
          }, /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
            type: "checkbox",
            checked: isSelected,
            onChange: function onChange(e) {
              _this3.handleRowSelect(e, rowIndex, false, rowEl.extra);
            }
          })));
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: rowClasses,
          key: "row-".concat(rowIndex),
          style: rowEl.style
        }, cols);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classes = (0, _classnames["default"])(this.props.className, "dataTable-component", this.props.typeStyle, {
        "sortable": this.props.enableSort,
        "selectableRow": this.props.selectableData,
        "hasStickyColumn": this.props.lastStickyColumnCount
      });
      var colNumber = this.props.headerContent.length;
      var headerContent, tableContent, stickyHeaderContent, stickyTableContent;

      if (this.props.lastStickyColumnCount > 0) {
        headerContent = this.fillHeader(this.props.headerContent.slice(0, -this.props.lastStickyColumnCount));
        tableContent = this.fillContent(this.props.tableContent, true);

        if (this.props.selectingIcon || this.props.selectableData) {
          stickyHeaderContent = this.fillHeader(this.props.headerContent.slice(colNumber - this.props.lastStickyColumnCount), true);
          stickyTableContent = this.fillContent(this.props.tableContent, true, true);
        } else {
          stickyHeaderContent = this.fillHeader(this.props.headerContent.slice(colNumber - this.props.lastStickyColumnCount), true);
          stickyTableContent = this.fillContent(this.props.tableContent, true, true);
        }
      } else {
        headerContent = this.fillHeader(this.props.headerContent);
        tableContent = this.fillContent(this.props.tableContent);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container"
      }, colNumber > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-header dataTable-row"
      }, headerContent), tableContent)), this.props.lastStickyColumnCount > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container sticky-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dataTable-header dataTable-row"
      }, stickyHeaderContent), stickyTableContent))));
    }
  }]);

  return DataTable;
}(_react.Component);

;
DataTable.propTypes = {
  headerContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    content: _propTypes["default"].any,
    style: _propTypes["default"].object,
    // minWidth is used for size
    className: _propTypes["default"].string,
    isSorting: _propTypes["default"].bool,
    extra: _propTypes["default"].any,
    notSortable: _propTypes["default"].bool
  })),
  tableContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    extra: _propTypes["default"].any,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object,
    cols: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      content: _propTypes["default"].any,
      style: _propTypes["default"].object,
      className: _propTypes["default"].string,
      extra: _propTypes["default"].any,
      notClickable: _propTypes["default"].bool
    }))
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  enableSort: _propTypes["default"].bool,
  selectedColIndex: _propTypes["default"].number,
  sortingIcon: _propTypes["default"].object,
  onHeadingClick: _propTypes["default"].func,
  selectableData: _propTypes["default"].bool,
  onDataSelect: _propTypes["default"].func,
  selectedRowIndex: _propTypes["default"].arrayOf(_propTypes["default"].number),
  selectingIcon: _propTypes["default"].object,
  lastStickyColumnCount: _propTypes["default"].number,
  selectAllChecked: _propTypes["default"].bool,
  withBorders: _propTypes["default"].bool,
  onRowClick: _propTypes["default"].func,
  sort: _propTypes["default"].oneOf(['asc', 'desc']),
  typeStyle: _propTypes["default"].oneOf(["default", "minimal"])
};
DataTable.defaultProps = {
  headerContent: [],
  tableContent: [],
  className: "",
  style: {},
  enableSort: false,
  selectedColIndex: null,
  // tell witch index is the colum sorting
  sortingIcon: null,
  // default icon override
  onHeadingClick: null,
  selectableData: false,
  onDataSelect: null,
  selectedRowIndex: [],
  // preselected rows
  selectingIcon: null,
  // selectingIcon icon override
  lastStickyColumnCount: 0,
  selectAllChecked: false,
  withBorders: false,
  onRowClick: null,
  sort: "asc",
  typeStyle: "default"
};
var _default = DataTable;
exports["default"] = _default;